import { configFactory, getOrThrow } from '@digitsole/blackburn-configuration';

export const websocketConfig = configFactory({
  url: getOrThrow('url', { type: 'string', prefix: 'blackburn', package: 'cloud/websocket' }) as string
});
